export default "__VITE_ASSET__BH99QzR3__"